/* Andrea - chatbot Lucangeli. Isole en Shadow DOM (n'affecte pas le theme). */
(function(){
  if (window.__lucangeliAndreaLoaded) return; window.__lucangeliAndreaLoaded = true;
  var __AV__ = 'https://cdn.shopify.com/s/files/1/0755/1575/6853/files/andrea-avatar.jpg?v=1787590964';
  function init(){
    var fl = document.createElement('link'); fl.rel='stylesheet';
    fl.href='https://fonts.googleapis.com/css2?family=Assistant:wght@300;400;600;700&family=Montserrat:wght@500;600;700&display=swap';
    document.head.appendChild(fl);
    var host = document.createElement('div'); host.id='lucangeli-andrea-host';
    document.body.appendChild(host);
    var root = host.attachShadow({mode:'open'});
    root.innerHTML = (`<style>

  :root{
    --terra:#ca5738;
    --terra-dark:#933d1c;
    --terra-grad:linear-gradient(90deg,#ca5738 0%,#642b1c 100%);
    --terra-grad-soft:linear-gradient(90deg,#d3663f 0%,#7a3620 100%);
    --cream-grad:linear-gradient(90deg,#fff9ee 0%,#ffe9c6 100%);
    --cream:#f7f3e5;
    --cream-text:#ffe9c6;
    --cream-deep:#efe7d3;
    --bot:#fffdf7;
    --olive:#7a8355;
    --olive-grad:linear-gradient(135deg,#8a9560 0%,#5f6a3e 100%);
    --ink:#2b2620;
    --muted:#7a7264;
    --line:#e7dfcd;
    --shadow:0 10px 40px rgba(60,40,20,.18);
    --display:'Montserrat',-apple-system,sans-serif; /* proxy de gravesend-sans */
    --body:'Assistant',-apple-system,BlinkMacSystemFont,sans-serif;
  }
  *{box-sizing:border-box;}
  html,body{height:100%;margin:0;}
  body{
    font-family:var(--body);
    background:
      radial-gradient(120% 90% at 70% 0%, #efe4cf 0%, #f7f3e5 55%, #f7f3e5 100%);
    color:var(--ink);
    overflow:hidden;
  }
  /* faint mock of the site behind, just for context */






  /* Launcher */
  .launcher{
    position:fixed;left:24px;bottom:24px;width:62px;height:62px;border-radius:50%;
    background:var(--olive-grad);color:var(--cream-text);border:none;cursor:pointer;
    box-shadow:var(--shadow);display:flex;align-items:center;justify-content:center;
    transition:transform .18s ease, filter .18s ease;z-index:40;
  }
  .launcher:hover{transform:translateY(-2px) scale(1.03);filter:brightness(1.06);}
  .launcher svg{width:28px;height:28px;}
  .online-dot{position:absolute;left:3px;bottom:3px;width:13px;height:13px;border-radius:50%;background:#3ec46d;border:2px solid #fff;box-shadow:0 0 0 0 rgba(62,196,109,.7);animation:opulse 2s infinite;}
  @keyframes opulse{0%{box-shadow:0 0 0 0 rgba(62,196,109,.6);}70%{box-shadow:0 0 0 6px rgba(62,196,109,0);}100%{box-shadow:0 0 0 0 rgba(62,196,109,0);}}

  /* Panel */
  .panel{
    position:fixed;left:24px;bottom:24px;width:384px;max-width:calc(100vw - 32px);
    height:600px;max-height:calc(100vh - 40px);
    background:var(--cream);border-radius:22px;box-shadow:var(--shadow);
    display:flex;flex-direction:column;overflow:hidden;z-index:41;
    border:1px solid #eaddc4;
    transform-origin:bottom left;
    animation:pop .22s cubic-bezier(.2,.8,.3,1);
  }
  @keyframes pop{from{transform:translateY(12px) scale(.96);}to{transform:none;}}

  /* Header */
  .head{
    background:var(--terra-grad);color:var(--cream-text);padding:16px 18px;display:flex;align-items:center;gap:12px;
  }
  .head .avatar{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.16);
    display:flex;align-items:center;justify-content:center;font-size:20px;flex:none;}
  .head .who{flex:1;min-width:0;}
  .head .who .name{font-family:var(--display);font-weight:700;letter-spacing:.16em;font-size:15px;}
  .head .who .role{font-size:12px;opacity:.85;margin-top:1px;display:flex;align-items:center;gap:6px;}
  .head .who .role .live{width:7px;height:7px;border-radius:50%;background:#a6e28a;box-shadow:0 0 0 0 rgba(166,226,138,.7);animation:pulse 2s infinite;}
  @keyframes pulse{0%{box-shadow:0 0 0 0 rgba(166,226,138,.6);}70%{box-shadow:0 0 0 7px rgba(166,226,138,0);}100%{box-shadow:0 0 0 0 rgba(166,226,138,0);}}
  .head .x{background:transparent;border:none;color:var(--cream);cursor:pointer;font-size:20px;opacity:.9;padding:4px;line-height:1;}
  .head .x:hover{opacity:1;}

  /* Messages */
  .msgs{flex:1;overflow-y:auto;padding:18px 16px 8px;display:flex;flex-direction:column;gap:12px;scroll-behavior:smooth;}
  .msgs::-webkit-scrollbar{width:8px;}
  .msgs::-webkit-scrollbar-thumb{background:#e2d6bd;border-radius:8px;}
  .row{display:flex;gap:8px;align-items:flex-end;max-width:100%;}
  .row.bot{justify-content:flex-start;}
  .row.user{justify-content:flex-end;}
  .bubble{padding:11px 14px;border-radius:16px;font-size:14.5px;line-height:1.5;max-width:82%;word-wrap:break-word;}
  .bot .bubble{background:var(--bot);border:1px solid var(--line);border-bottom-left-radius:5px;box-shadow:0 2px 8px rgba(60,40,20,.05);}
  .user .bubble{background:var(--terra-grad);color:var(--cream-text);border-bottom-right-radius:5px;}
  .bubble b{font-weight:700;}
  .bubble .sign{color:var(--olive);font-weight:600;margin-top:6px;display:block;}
  .mini-av{width:26px;height:26px;border-radius:50%;background:var(--cream-deep);display:flex;align-items:center;justify-content:center;font-size:14px;flex:none;}

  /* Quick replies (pills, façon site) */
  .chips{display:flex;flex-wrap:wrap;gap:8px;padding:2px 6px 6px 40px;}
  .chip{
    font-family:var(--body);font-weight:600;font-size:13px;letter-spacing:.03em;
    background:var(--terra-grad);color:var(--cream-text);border:none;
    border-radius:999px;padding:9px 17px;cursor:pointer;transition:all .16s ease;
    box-shadow:0 3px 10px rgba(148,61,28,.22);
  }
  .chip:hover{filter:brightness(1.07);transform:translateY(-1px);box-shadow:0 5px 14px rgba(148,61,28,.28);}

  /* Product cards */
  .prods{display:flex;flex-direction:column;gap:8px;padding:2px 6px 6px 40px;}
  .prod{display:flex;align-items:center;gap:12px;background:var(--bot);border:1px solid var(--line);border-radius:14px;padding:9px 11px;text-decoration:none;color:var(--ink);transition:transform .15s,border-color .15s;}
  .prod:hover{transform:translateX(2px);border-color:var(--terra);}
  .prod .thumb{width:42px;height:42px;border-radius:10px;flex:none;display:flex;align-items:center;justify-content:center;font-size:22px;background:var(--cream-deep);}
  .prod .pinfo{flex:1;min-width:0;}
  .prod .pinfo .pn{font-weight:700;font-size:13.5px;}
  .prod .pinfo .pd{font-size:12px;color:var(--muted);}
  .prod .go{color:var(--terra);font-weight:700;font-size:18px;}

  /* typing */
  .typing .bubble{display:flex;gap:4px;align-items:center;padding:14px;}
  .typing .dot{width:7px;height:7px;border-radius:50%;background:#c9b89a;animation:blink 1.2s infinite;}
  .typing .dot:nth-child(2){animation-delay:.2s;}
  .typing .dot:nth-child(3){animation-delay:.4s;}
  @keyframes blink{0%,60%,100%{opacity:.3;}30%{opacity:1;}}

  /* Input */
  .composer{border-top:1px solid var(--line);background:var(--cream);padding:10px 12px;}
  .cbar{display:flex;align-items:center;gap:8px;background:#fff;border:1px solid var(--line);border-radius:999px;padding:5px 6px 5px 14px;}
  .cbar input{flex:1;border:none;outline:none;background:transparent;font-family:var(--body);font-size:14.5px;color:var(--ink);}
  .cbar .clip{background:transparent;border:none;cursor:pointer;color:var(--muted);display:flex;padding:6px;}
  .cbar .clip:hover{color:var(--terra);}
  .cbar .send{background:var(--terra-grad);border:none;width:38px;height:38px;border-radius:50%;cursor:pointer;color:var(--cream-text);display:flex;align-items:center;justify-content:center;flex:none;transition:filter .15s;}
  .cbar .send:hover{filter:brightness(1.08);}
  .hidden{display:none !important;}
  .avatar svg,.mini-av svg,.avatar img,.mini-av img{width:100%;height:100%;border-radius:50%;display:block;object-fit:cover;}
  .avatar{overflow:hidden;padding:0;}
  .mini-av{overflow:hidden;padding:0;background:transparent;}

  /* teaser (etat ferme facon Copernic) */
  .teaser{position:fixed;left:24px;bottom:98px;max-width:300px;display:flex;align-items:flex-start;gap:10px;background:var(--olive-grad);border:none;border-radius:16px;border-bottom-left-radius:6px;padding:12px 14px 12px 12px;box-shadow:var(--shadow);cursor:pointer;animation:pop .3s cubic-bezier(.2,.8,.3,1);}
  .teaser:hover{filter:brightness(.99);}
  .teaser .teaser-av{width:34px;height:34px;border-radius:50%;overflow:hidden;flex:none;background:var(--cream-deep);}
  .teaser .teaser-av img{width:100%;height:100%;object-fit:cover;display:block;}
  .teaser .teaser-txt{font-family:var(--body);font-size:13.5px;line-height:1.4;color:var(--cream-text);}
  .teaser .teaser-x{position:absolute;top:-9px;left:-9px;width:22px;height:22px;border-radius:50%;background:#fff;border:1px solid var(--line);color:var(--muted);cursor:pointer;font-size:12px;line-height:1;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(60,40,20,.14);padding:0;}

/* embed overrides */
.launcher,.panel,.teaser{z-index:2147483000 !important;}
</style>
<!-- Launcher -->
  <button class="launcher" id="launcher" aria-label="Ouvrir le chat">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg><span class="online-dot"></span>
  </button>
<div class="teaser" id="teaser">
    <button class="teaser-x" id="teaser-x" aria-label="Fermer">✕</button>
    <div class="teaser-av"><img alt="Andrea" src="__ANDREA_AVATAR__"></div>
    <div class="teaser-txt" id="teaser-txt"></div>
  </div>
<div class="panel hidden" id="panel">
    <div class="head">
      <div class="avatar"><img alt="Andrea" src="__ANDREA_AVATAR__"></div>
      <div class="who">
        <div class="name">ANDREA</div>
        <div class="role"><span class="live"></span> La squadra Lucangeli</div>
      </div>
      <button class="x" id="close" aria-label="Fermer">✕</button>
    </div>

    <div class="msgs" id="msgs"></div>

    <div class="composer">
      <div class="cbar">
        <button class="clip" title="Joindre une photo ou un PDF" aria-label="Joindre un fichier">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
        </button>
        <input id="input" type="text" placeholder="Écrivez votre message…" autocomplete="off">
        <button class="send" id="send" aria-label="Envoyer">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </button>
      </div>
    </div>
  </div>`).replace(/__ANDREA_AVATAR__/g, __AV__);

  const WEBHOOK_URL = 'https://melomelomelo.app.n8n.cloud/webhook/lucangeli-chat-v1/chat';
  const AV = '<div class="mini-av"><img alt="Andrea" src="' + __AV__ + '"></div>';

  // Message + boutons d'accueil selon la page (ordre = du plus specifique au plus general)
  const PAGE_RULES = [
    {k:"/pages/professionnels", w:"Comment rendre les tables de mon restaurant uniques ?", b:["Consulter nos services 🤝","Obtenir mon devis 🧾","Recevoir ma maquette personnalisée 🎨"]},
    {k:"/pages/particuliers", w:"Comment contribuer à rendre votre journée inoubliable ? 🥂", b:["Personnaliser pour un mariage 💒","Options pour événements 🎊","Demander une projection 🧑‍🎨"]},
    {k:"nos-huiles-dolives-bio", w:"Ciao, quelle huile d'olive choisir ? Une question ? 🌼", b:["Quelle huile d'olive choisir ?","Une question sur nos huiles d'olive ?","Idées recettes avec nos huiles d'olive ? 🍝"]},
    {k:"carte-cadeau", w:"Souhaitez-vous gâter quelqu'un aujourd'hui ? 🎁", b:["Pourquoi offrir votre carte cadeau ? 🎁","Comment utiliser la carte cadeau Lucangeli ? 🌟","Quels sont les avantages de votre carte cadeau ? ✨"]},
    {k:"coffret", w:"Souhaitez-vous gâter quelqu'un aujourd'hui ? 🎁", b:["Que contient ce coffret ? 🎁","Pour quelles occasions offrir ce coffret ? 🎉","Comment personnaliser ce coffret ? ✍️"]},
    {k:"puree-de-noisette", w:"Des questions sur nos délices ? 🤩", b:["Quels sont les avantages de la purée de noisette 100% ? 🌰","Comment l'utiliser dans mes recettes ? 🥞","D'où proviennent nos noisettes ? 📍"]},
    {k:"puree-de-pistache", w:"Des questions sur nos délices ? 🤩", b:["Quels sont les avantages de la purée de pistache 100% ? 🍃","Idées gourmandes avec votre purée de pistache ? 🍰","Comment assurez-vous la qualité de vos pistaches ? 💚"]},
    {k:"puree-amande", w:"Des questions sur nos délices ? 🤩", b:["Pourquoi choisir votre purée d'amande 100% ? 🌟","Comment l'intégrer dans mon alimentation ? 🍲","D'où viennent vos amandes ? 📍"]},
    {k:"puree", w:"Des questions sur nos délices ? 🤩", b:["Comment déguster nos purées 100% ? 🥞","D'où viennent nos fruits à coque ? 📍"]},
    {k:"pate-a-tartiner", w:"Des questions sur nos délices ? 🤩", b:["Quels sont les ingrédients de cette pâte à tartiner ?","Comment la déguster ? 🍰"]},
    {k:"confiture", w:"Des questions sur nos délices ? 🤩", b:["Comment est fabriquée votre douceur de bergamote ? 🌟","Quels usages conseillez-vous ? 🥞","Quels sont les ingrédients ? 🍋"]},
    {k:"jus", w:"Des questions sur nos délices ? 🤩", b:["Quels sont les bienfaits du jus de bergamote ? 🌼","Comment profiter au mieux de notre jus 100% ? ☀️","D'où provient votre bergamote ? 🍋"]},
    {k:"huile", w:"Ciao, quelle huile d'olive choisir ? Une question ? 🌼", b:["Quelle huile d'olive choisir ? 🌿","Comment l'utiliser dans mes recettes ? 🍝","En savoir plus sur la production ? 🇮🇹"]},
    {k:"vinaigre", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Comment est produit ce vinaigre ? 🌟","Quelles associations culinaires recommandez-vous ? 🥗","Quelle est la durée de conservation ? ⏳"]},
    {k:"pesto", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Quels ingrédients dans notre pesto ? 🌱","Comment l'utiliser dans mes plats ? 🍝","Est-ce que notre pesto est 100% naturel ? ✨"]},
    {k:"caviar", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Quels ingrédients composent ce produit ?","Comment l'intégrer dans un apéritif ? 🍹"]},
    {k:"saumure", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Comment sont préparées vos olives en saumure ? 🌶️","Suggestions de pairings avec nos olives ?","Quels sont les bienfaits des olives en saumure ? 💚"]},
    {k:"denoyautees", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Quelles variétés d'olives utilisez-vous ? 🌿","Comment déguster les olives dénoyautées ?","D'où viennent nos olives ? 🇮🇹"]},
    {k:"tartinable", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Quels ingrédients composent ce produit ?","Comment l'intégrer dans un apéritif ? 🍹"]},
    {k:"bergamote", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Tous vos produits à la bergamote ? 🍋","Idées recettes à la bergamote ? 🍝","D'où vient votre bergamote ? 🇮🇹"]},
    {k:"/epicerie-salee", w:"Ciao, quel produit choisir ? Une question ? 💚", b:["Quel produit choisir ?","Idées pour un apéro parfait ?"]},
    {k:"/epicerie-sucree", w:"Des questions sur nos délices ? 🤩", b:["Quel délice choisir ?","Idées gourmandes ? 🍰"]}
  ];
  const DEFAULT_RULE = {w:"Benvenuti 🇮🇹 Comment puis-je vous conseiller ?", b:["J'ai besoin de conseil sur vos produits 🌿","J'ai une question sur ma commande 🚚","Les idées recette de Nonna 👵🏼"]};

  function pickRule(){
    const params = new URLSearchParams(location.search);
    const test = (params.get('p')||'').toLowerCase();
    const url = (test ? test : (location.pathname + location.search)).toLowerCase();
    for (const r of PAGE_RULES){ if (url.indexOf(r.k.toLowerCase()) !== -1) return r; }
    return DEFAULT_RULE;
  }

  const msgs = root.getElementById('msgs');
  const panel = root.getElementById('panel');
  const launcher = root.getElementById('launcher');
  const input = root.getElementById('input');
  const sessionId = 'lucangeli-' + Math.random().toString(36).slice(2) + '-' + Date.now();
  let busy = false;

  // --- Journalisation conversations + geoloc (Notion via n8n) — invisible pour le visiteur ---
  var LOG_URL = 'https://melomelomelo.app.n8n.cloud/webhook/andrea-log';
  var __geo = null;
  try {
    fetch('https://ipwho.is/', {cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(g){ if (g && g.success !== false) { __geo = { country: g.country, country_code: g.country_code, region: g.region, city: g.city, lat: g.latitude, lon: g.longitude }; } })
      .catch(function(){});
  } catch(e){}
  function logConv(userMsg, botReply){
    try {
      fetch(LOG_URL, {
        method: 'POST', headers: {'Content-Type':'application/json'}, keepalive: true,
        body: JSON.stringify({ sessionId: sessionId, message: userMsg, reply: botReply, geo: __geo, page: location.pathname + location.search, url: location.href, ts: new Date().toISOString() })
      }).catch(function(){});
    } catch(e){}
  }

  function scrollBottom(){ msgs.scrollTop = msgs.scrollHeight; }
  function escapeHtml(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function mdToHtml(t){
    let s = escapeHtml(t.trim());
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    s = s.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    s = s.replace(/\n/g, '<br>');
    return s;
  }
  function addBot(html){
    const row = document.createElement('div');
    row.className = 'row bot';
    row.innerHTML = AV + '<div class="bubble">'+html+'</div>';
    msgs.appendChild(row); scrollBottom();
  }
  function userBubble(text){
    const row = document.createElement('div');
    row.className = 'row user';
    row.innerHTML = '<div class="bubble">'+escapeHtml(text)+'</div>';
    msgs.appendChild(row); scrollBottom();
  }
  function chips(items){
    const wrap = document.createElement('div');
    wrap.className = 'chips';
    items.forEach(label=>{
      const b = document.createElement('button');
      b.className='chip'; b.textContent = label;
      b.onclick = ()=>{ wrap.remove(); sendMessage(label); };
      wrap.appendChild(b);
    });
    msgs.appendChild(wrap); scrollBottom();
  }
  function showTyping(){
    const row = document.createElement('div');
    row.className='row bot typing';
    row.innerHTML= AV + '<div class="bubble"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>';
    msgs.appendChild(row); scrollBottom();
    return row;
  }
  function extractReply(data){
    if (data == null) return '';
    if (typeof data === 'string') return data;
    if (Array.isArray(data)) { for (const it of data){ const r = extractReply(it); if (r) return r; } return ''; }
    return data.output || data.text || data.message || data.response || data.answer || '';
  }
  function eurPrice(c){ var v=Number(c)/100; return (v%1===0? v.toFixed(0): v.toFixed(2).replace('.',',')) + ' €'; }
  function productCards(handles){
    if(!handles.length) return;
    var wrap = document.createElement('div'); wrap.className='prods';
    msgs.appendChild(wrap); scrollBottom();
    handles.slice(0,4).forEach(function(h){
      fetch('/products/'+h+'.js').then(function(r){ return r.ok? r.json(): null; }).then(function(p){
        if(!p) return;
        var img=(p.featured_image||'').replace(/^\/\//,'https://');
        var a=document.createElement('a');
        a.className='prod'; a.href='/products/'+h; a.target='_blank'; a.rel='noopener';
        a.innerHTML='<span class="thumb" style="background-image:url(\''+img+'\');background-size:cover;background-position:center;"></span><span class="pinfo"><span class="pn">'+escapeHtml(p.title)+'</span><span class="pd">'+eurPrice(p.price)+'</span></span><span class="go">›</span>';
        wrap.appendChild(a); scrollBottom();
      }).catch(function(){});
    });
  }
  function renderBotReply(raw){
    let text = (raw || '').trim();
    if (!text){ addBot("Je n'ai pas reçu de réponse cette fois, réessayez dans un instant 🌸"); return; }
    let options = null;
    const m = text.match(/\[\s*"(?:[^"\\]|\\.)*"(?:\s*,\s*"(?:[^"\\]|\\.)*")*\s*\]/);
    if (m){ try { options = JSON.parse(m[0]); text = (text.slice(0, m.index) + ' ' + text.slice(m.index + m[0].length)).replace(/[ \t]+/g,' ').replace(/ *\n */g,'\n').trim(); } catch(e){ options = null; } }
    if (text) addBot(mdToHtml(text));
    var _ph = (text.match(/\/products\/[a-z0-9\-]+/gi)||[]).map(function(x){ return x.replace(/.*\/products\//,'').split(/[?#]/)[0]; });
    productCards([...new Set(_ph)]);
    if (options && options.length) chips(options);
  }
  function sendMessage(text){
    if (busy) return; busy = true;
    userBubble(text);
    const t = showTyping();
    fetch(WEBHOOK_URL, {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ action:'sendMessage', sessionId: sessionId, chatInput: text })
    })
    .then(r => r.ok ? r.json() : Promise.reject('HTTP '+r.status))
    .then(data => { t.remove(); var __reply = extractReply(data); renderBotReply(__reply); logConv(text, __reply); })
    .catch(err => {
      t.remove();
      addBot("Oups, un petit souci de connexion de mon côté. Réessayez dans un instant, la squadra revient vite 🌸");
      console.error('[Lucangeli] Erreur bot n8n:', err);
    })
    .finally(()=>{ busy = false; });
  }
  let welcomed = false;
  function welcome(){
    if (welcomed) return; welcomed = true;
    const r = pickRule();
    addBot(r.w);
    chips(r.b);
  }
  const teaser = root.getElementById('teaser');
  const teaserTxt = root.getElementById('teaser-txt');
  (function(){ try{ var __st=document.createElement('style'); __st.textContent='body.andrea-chat-open [id^="smile-ui"],body.andrea-chat-open [id^="smile-lite"],body.andrea-chat-open #smile-ui-lite-container{display:none !important;visibility:hidden !important;opacity:0 !important;pointer-events:none !important;}'; document.head.appendChild(__st); }catch(e){} })();
  function openPanel(){ launcher.classList.add('hidden'); teaser.classList.add('hidden'); panel.classList.remove('hidden'); document.body.classList.add('andrea-chat-open'); welcome(); }
  function closePanel(){ panel.classList.add('hidden'); launcher.classList.remove('hidden'); document.body.classList.remove('andrea-chat-open'); }
  function send(){ const v = input.value.trim(); if(!v) return; input.value=''; welcome(); sendMessage(v); }
  root.getElementById('send').onclick = send;
  input.addEventListener('keydown', e=>{ if(e.key==='Enter') send(); });
  root.getElementById('close').onclick = closePanel;
  launcher.onclick = openPanel;
  teaserTxt.textContent = pickRule().w;
  teaser.addEventListener('click', openPanel);
  root.getElementById('teaser-x').addEventListener('click', function(e){ e.stopPropagation(); teaser.classList.add('hidden'); });
  panel.classList.add('hidden'); launcher.classList.remove('hidden'); teaser.classList.remove('hidden');

  // --- Barre de discussion inline sur les fiches produit (sous la description) ---
  function injectProductBar(){
    if (location.pathname.indexOf('/products/') === -1) return true;
    if (document.getElementById('andrea-pbar')) return true;
    var anchor = document.querySelector('.titre-desc-wrapper') || document.querySelector('.product__description');
    if (!anchor) return false;
    if (!document.getElementById('andrea-pbar-style')){
      var st = document.createElement('style'); st.id='andrea-pbar-style';
      st.textContent = ".andrea-pbar{display:flex;align-items:center;gap:9px;margin:30px 0 18px !important;padding:7px 7px 7px 12px;background:#fffdf7;border:1px solid #e7dfcd;border-radius:999px;box-shadow:0 4px 16px rgba(60,40,20,.08);width:100%;box-sizing:border-box;cursor:text;font-family:'Assistant',-apple-system,BlinkMacSystemFont,sans-serif;transition:border-color .16s,box-shadow .16s;}"
        + ".andrea-pbar:hover,.andrea-pbar:focus-within{border-color:#ca5738;box-shadow:0 6px 20px rgba(148,61,28,.14);}"
        + ".andrea-pbar .apb-av{position:relative;width:36px;height:36px;border-radius:50%;object-fit:cover;flex:none;}"
        + ".andrea-pbar .apb-avwrap{position:relative;flex:none;line-height:0;}"
        + ".andrea-pbar .apb-dot{position:absolute;right:0;bottom:0;width:10px;height:10px;border-radius:50%;background:#3ec46d;border:2px solid #fffdf7;}"
        + ".andrea-pbar .apb-input{flex:1;border:none;outline:none;background:transparent;font-size:16px;color:#2b2620;font-family:inherit;min-width:0;}"
        + ".andrea-pbar .apb-input::placeholder{color:#7a7264;}"
        + ".andrea-pbar .apb-send{flex:none;width:38px;height:38px;border-radius:50%;border:none;cursor:pointer;background:linear-gradient(90deg,#ca5738 0%,#642b1c 100%);color:#ffe9c6;display:flex;align-items:center;justify-content:center;transition:filter .15s;}"
        + ".andrea-pbar .apb-send:hover{filter:brightness(1.08);}"
        + ".andrea-psugg{display:flex;flex-wrap:wrap;gap:10px;margin:0 0 34px !important;font-family:'Assistant',-apple-system,BlinkMacSystemFont,sans-serif;}"
        + ".andrea-psugg .apb-chip{font-weight:600;font-size:15px;line-height:1.25;background:linear-gradient(90deg,#ca5738 0%,#642b1c 100%);color:#ffe9c6;border:none;border-radius:999px;padding:11px 19px;cursor:pointer;box-shadow:0 3px 10px rgba(148,61,28,.2);transition:filter .15s,transform .15s;}"
        + ".andrea-psugg .apb-chip:hover{filter:brightness(1.07);transform:translateY(-1px);box-shadow:0 5px 14px rgba(148,61,28,.28);}";
      document.head.appendChild(st);
    }
    var bar = document.createElement('div'); bar.id='andrea-pbar'; bar.className='andrea-pbar';
    bar.innerHTML = '<span class="apb-avwrap"><img class="apb-av" src="'+__AV__+'" alt="Andrea"><span class="apb-dot"></span></span>'
      + '<input class="apb-input" id="apb-input" type="text" placeholder="Une question ? Discutez avec Andrea 🌿" autocomplete="off">'
      + '<button class="apb-send" id="apb-send" type="button" aria-label="Envoyer"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>';
    anchor.insertAdjacentElement('afterend', bar);
    var pin = bar.querySelector('#apb-input');
    function go(){ var v = pin.value.trim(); openPanel(); if(v){ pin.value=''; sendMessage(v); } try{ pin.blur(); }catch(e){} }
    bar.querySelector('#apb-send').addEventListener('click', function(e){ e.preventDefault(); go(); });
    pin.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); go(); } });
    // 2 questions suggerees, propres a chaque produit (memes regles que l'accueil vert)
    try {
      var __qs = (pickRule().b || []).slice(0, 2);
      if (__qs.length){
        var sg = document.createElement('div'); sg.id='andrea-psugg'; sg.className='andrea-psugg';
        __qs.forEach(function(q){
          var c = document.createElement('button'); c.type='button'; c.className='apb-chip'; c.textContent = q;
          c.addEventListener('click', function(e){ e.preventDefault(); openPanel(); sendMessage(q); });
          sg.appendChild(c);
        });
        bar.insertAdjacentElement('afterend', sg);
      }
    } catch(e){}
    return true;
  }
  if (location.pathname.indexOf('/products/') !== -1){
    if (!injectProductBar()){ var __pn=0; var __piv=setInterval(function(){ if (injectProductBar() || ++__pn>12){ clearInterval(__piv); } }, 400); }
  }

  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();